import {
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { withStyles } from "@mui/styles";

import Close from "@mui/icons-material/Close";

const StyledDialogActions = withStyles({
  root: {
    alignItems: "left",
    justifyContent: "left",
    display: "block",
    paddingLeft: "1.0em",
  },
  spacing: {
    justifyContent: "left",
    alignItems: "left",
  },
})(DialogActions);

export function ConfirmModal(props) {
  const { onConfirm, onClose, title, bodyText } = props;

  return (
    <Dialog
      open={true}
      keepMounted
      onClose={() => onClose}
      aria-labelledby="modal-slide-title"
      aria-describedby="modal-slide-description"
    >
      <DialogTitle id="classic-modal-slide-title">
        <div style={{ width: "100%", textAlign: "right" }}>
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => onClose}
            size="large">
            <Close />
          </IconButton>
        </div>
        <div style={{ width: "90%" }}>
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent id="modal-slide-description">{bodyText}</DialogContent>
      <StyledDialogActions>
        <Button onClick={() => onClose()} color="primary">
          No
        </Button>
        <Button onClick={() => onConfirm()} color="secondary">
          Yes
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
}
